<template>
    <div class="container">
        <h1>嘎嘎狗聲明:</h1>
        <p>本網站為私人投資看盤工具，</p>
        <p>不負責資料面的正確性，也沒有提供任何投資建議</p>
        <p>如你使用本網站做投資而造成任何虧損, 純屬你個人意志及行為, 一切與本站無關。</p>
        <p>本網站不會收集任何個人資料, 也不會使用 Cookies</p>
        <p>本網站沒有與任何第三方合作服務</p>
        <p>本網站不會使用任何分析工具</p>
        <p>本網站不會使用任何社交媒體</p>
        <p>本網站不會使用任何追蹤工具</p>
        <p>本網站不會使用任何廣告網路</p>
        <p>如果有任何第三方利用本網站做詐騙或任何不法行為, 本網站將追朔法律責任及本人損失</p>
    </div>
</template>
<script>
export default {
  name: 'HomeView'
}
</script>
<script setup>

</script>